import React, { Component } from 'react';
import './App.css';
import { ShowProject, ShowIntro, ShowCV } from './ShowProject';
import { IProps, IState, PreviewCVObject, PreviewObject } from './types'

export class App extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      selectedProject: undefined,
      introShowing: localStorage.getItem("IntroWasViewed") ? false : true,
    };
  }

  introText: Array<any> = [
    <p style={{ display: "inline-block" }}>Welcome to JUULS TRINKETS.<br />
      The best bargain bin west of Storebaelt, here you can find anything your heart desires. <p style={{ fontSize: "10px" }}>If we have it in stock.</p>
    </p>
  ]

  sliderGrabbed = false;
  areas: Array<PreviewObject> = [
    { name: "Price-bot", img: "Images/ProjectImages/price-bot.png", key: "price_bot", imageStyle: "logo", downloadKey: "https://github.com/Sekionn/Price-scanner/releases/latest/download/price-bot-win-Setup.exe", url: "https://github.com/Sekionn/Price-scanner", downloadType: 3 },
    { name: "EG Ajour", img: "Images/ProjectImages/eg_ajour_logo.svg", key: "eg_ajour", imageStyle: "logo", url: `https://eg.dk/it/eg-ajour/`, downloadType: 2 },
    { name: "Again", img: "Images/ProjectImages/again.png", key: "again", downloadKey: "Again.zip", downloadType: 1 },
    { name: "Boss Slayers", img: "Images/ProjectImages/bossSlayers.png", key: "bossSlayers", downloadKey: "BossSlayers.zip", downloadType: 1 },
    { name: "Escape", img: "Images/ProjectImages/escape.png", key: "escape", downloadKey: "Escape.zip", downloadType: 1 },
    { name: "Introvert Shopping", img: "Images/ProjectImages/introShop.png", key: "introShop", downloadKey: "IntrovertShopping.zip", downloadType: 1 },
    { name: "School", img: "Images/ProjectImages/school.png", key: "school", downloadKey: "School.zip", downloadType: 1 },
    { name: "Silk Route", img: "Images/ProjectImages/silkroutegame.png", key: "silkroutegame", downloadKey: "Silkroute.zip", downloadType: 1 }];

  projectSelected?: PreviewObject;
  dragging: boolean = false;
  curriculum: PreviewCVObject = {name: "Curriculum vitae", key: "curriculum_vitae", img:"Images/icons8-document-64.png", downloadKey: "curriculum_vitae.pdf"};

  changeProject() {
    this.setState(() => ({
      selectedProject: undefined,
    }));
  }
  changeCV() {
    this.setState(() => ({
      cvSelected: false,
      cvData: undefined,
    }));
  }

  setIntroToViewed() {
    localStorage.setItem("IntroWasViewed", "true");
    this.setState(() => ({
      selectedProject: undefined,
      introShowing: false
    }));
  }

  handleEvent(event: any) {
    const slider = document.querySelector(".slider-inner") as HTMLDivElement;
    if (event.type === 'mousedown') {
      this.sliderGrabbed = true;
      this.dragging = false;
    } else if (event.type === 'mouseup') {
      this.sliderGrabbed = false;
    } else if (event.type === 'mouseleave') {
      this.sliderGrabbed = false;
      this.dragging = false;
    } else if (event.type === 'scroll') {
      const progressBar = document.querySelector(".inner-bar") as HTMLDivElement;
      progressBar.style.width = `${this.getScrollPercentage(slider, progressBar.style.width)}%`

    } else if (event.type === 'wheel' && slider.parentElement) {
      event.preventDefault()
      slider.parentElement.scrollLeft += event.deltaY;
    }
  }

  getScrollPercentage(slider: HTMLDivElement, currentPercentage: string) {
    let percentage;
    if (slider.parentElement) {
      percentage = ((slider.parentElement.scrollLeft / (slider.parentElement.scrollWidth - slider.parentElement.clientWidth)) * 100)
    }
    return percentage ? percentage : currentPercentage;
  }

  handleMouseMove(event: any) {
    event.preventDefault()
    event.stopPropagation()
    this.dragging = true;
    const slider = (document.querySelector('.slider-inner') as HTMLDivElement);
    if (this.sliderGrabbed && slider.parentElement) {
      slider.parentElement.scrollLeft -= event.movementX;
    }
  }

  handleClick(clickedObject: PreviewObject) {
    if (this.dragging !== true) {
      this.projectSelected = clickedObject;
      this.setState(() => ({
        selectedProject: clickedObject,
      }));
    }
  }

  handleCVClick(clickedObject: PreviewCVObject){
    this.setState(() => ({
      cvSelected: true,
      cvData: clickedObject
    }));
  }

  render() {
    if (this.state.introShowing) {
      return ShowIntro(this.introText[0], this.setIntroToViewed.bind(this));
    }

    if (this.state.cvSelected) {
      return (
        <ShowCV selectedProject={this.state.cvData!} changeProject={this.changeCV.bind(this)} />
      );    
    }
    return this.showProject();
  }

  showProject() {
    if (!this.state.selectedProject) {
      return (
        <div className="App">
          <body style={{ overflow: "hidden" }}>
            <img src={require('./Images/Welcome.png')} alt='Not available' style={{ width: "100vw", height: "100vh", objectFit: "contain" }} />
            <div className='slider-wrap'>
            <div className='cv-item' onClick={() => this.handleCVClick(this.curriculum)}><img className='project-images' src={require("./"+this.curriculum.img)} alt="" />{this.curriculum.name}</div>
              <div className="slider" onMouseEnter={(e) => this.handleEvent(e)} onMouseDown={(e) => this.handleEvent(e)} onMouseMove={(e) => this.handleMouseMove(e)} onMouseLeave={(e) => this.handleEvent(e)} onMouseUp={(e) => this.handleEvent(e)} onScroll={(e) => this.handleEvent(e)} onWheel={(e) => this.handleEvent(e)}>
                <div className='slider-inner' >
                  {this.areas.map((area) => (
                    <div className='slide-img' title={area.name} onClick={() => this.handleClick(area)}> {area.img ? <img className='project-images' src={require("./"+area.img)} alt="" /> : ''}
                      {area.name}
                    </div>
                  ))}
                </div>
              </div>
              <div className='progress-bar'>
                <div className='inner-bar'></div>
              </div>
            </div>
          </body>
        </div>
      );
    } else {
      return (
        <ShowProject selectedProject={this.state.selectedProject!} changeProject={this.changeProject.bind(this)} />
      );
    }
  }
}